import { render, staticRenderFns } from "./Loggs.vue?vue&type=template&id=50434445"
import script from "./Loggs.vue?vue&type=script&lang=js"
export * from "./Loggs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports